module.exports = {
      id: "rain-usage",
      viewBox: "0 0 38.4 27.718",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#rain",
      toString: function () {
        return this.url;
      }
    }